;(function () {
  if (window.__cmpTableInitBound) return
  window.__cmpTableInitBound = true

  function initDesktopScrollbar(section) {
    if (section.dataset.desktopScrollInit === 'true') return

    var desktopWrap = section.querySelector('[data-cmp-desktop]')
    var scrollArea = section.querySelector('[data-cmp-scroll-area]')
    var scrollbar = section.querySelector('[data-cmp-scrollbar]')
    var track = section.querySelector('[data-cmp-scroll-track]')
    var thumb = section.querySelector('[data-cmp-scroll-thumb]')

    if (!desktopWrap || !scrollArea || !scrollbar || !track || !thumb) return

    section.dataset.desktopScrollInit = 'true'

    var isDraggingTable = false
    var isDraggingThumb = false
    var tableStartX = 0
    var tableStartScrollLeft = 0
    var thumbStartX = 0
    var thumbStartScrollLeft = 0

    var getMetrics = function () {
      var clientWidth = scrollArea.clientWidth
      var scrollWidth = scrollArea.scrollWidth
      var maxScrollLeft = Math.max(scrollWidth - clientWidth, 0)
      var trackWidth = track.clientWidth
      var thumbWidth = Math.max((clientWidth / Math.max(scrollWidth, 1)) * trackWidth, 48)
      var maxThumbLeft = Math.max(trackWidth - thumbWidth, 0)

      return {
        maxScrollLeft: maxScrollLeft,
        trackWidth: trackWidth,
        thumbWidth: thumbWidth,
        maxThumbLeft: maxThumbLeft,
      }
    }

    var syncThumb = function () {
      var metrics = getMetrics()
      var maxScrollLeft = metrics.maxScrollLeft
      var thumbWidth = metrics.thumbWidth
      var maxThumbLeft = metrics.maxThumbLeft

      if (maxScrollLeft <= 0 || thumbWidth >= track.clientWidth) {
        scrollbar.classList.add('is-hidden')
        thumb.style.width = '0px'
        thumb.style.transform = 'translateX(0px)'
        return
      }

      scrollbar.classList.remove('is-hidden')
      thumb.style.width = thumbWidth + 'px'

      var ratio = scrollArea.scrollLeft / maxScrollLeft
      var thumbLeft = ratio * maxThumbLeft
      thumb.style.transform = 'translateX(' + thumbLeft + 'px)'
    }

    var setScrollFromTrackPosition = function (trackX) {
      var metrics = getMetrics()
      var maxScrollLeft = metrics.maxScrollLeft
      var thumbWidth = metrics.thumbWidth
      var maxThumbLeft = metrics.maxThumbLeft
      if (maxScrollLeft <= 0) return

      var targetLeft = Math.min(Math.max(trackX - thumbWidth / 2, 0), maxThumbLeft)
      var ratio = maxThumbLeft > 0 ? targetLeft / maxThumbLeft : 0
      scrollArea.scrollLeft = ratio * maxScrollLeft
    }

    var onTableMouseDown = function (event) {
      if (event.button !== 0) return
      if (event.target.closest('a, button, input, textarea, select, label')) return
      isDraggingTable = true
      tableStartX = event.pageX
      tableStartScrollLeft = scrollArea.scrollLeft
      scrollArea.classList.add('is-dragging')
      event.preventDefault()
    }

    var onThumbMouseDown = function (event) {
      if (event.button !== 0) return
      isDraggingThumb = true
      thumbStartX = event.pageX
      thumbStartScrollLeft = scrollArea.scrollLeft
      thumb.classList.add('is-dragging')
      event.preventDefault()
      event.stopPropagation()
    }

    var onTrackMouseDown = function (event) {
      if (event.button !== 0) return
      if (event.target === thumb) return
      var rect = track.getBoundingClientRect()
      var trackX = event.clientX - rect.left
      setScrollFromTrackPosition(trackX)
      event.preventDefault()
    }

    var onWindowMouseMove = function (event) {
      if (isDraggingTable) {
        var deltaXTable = event.pageX - tableStartX
        scrollArea.scrollLeft = tableStartScrollLeft - deltaXTable
      }

      if (isDraggingThumb) {
        var metrics = getMetrics()
        var maxScrollLeft = metrics.maxScrollLeft
        var maxThumbLeft = metrics.maxThumbLeft
        if (maxScrollLeft <= 0 || maxThumbLeft <= 0) return
        var deltaXThumb = event.pageX - thumbStartX
        var scrollRatio = deltaXThumb / maxThumbLeft
        var target = thumbStartScrollLeft + scrollRatio * maxScrollLeft
        scrollArea.scrollLeft = Math.min(Math.max(target, 0), maxScrollLeft)
      }
    }

    var onWindowMouseUp = function () {
      isDraggingTable = false
      isDraggingThumb = false
      scrollArea.classList.remove('is-dragging')
      thumb.classList.remove('is-dragging')
    }

    var stickyHeader = section.querySelector('[data-cmp-sticky-header]')
    var syncStickyZ = function () {
      if (!stickyHeader) return
      stickyHeader.style.zIndex = scrollArea.scrollLeft > 0 ? '1' : ''
    }

    scrollArea.addEventListener('scroll', syncThumb, { passive: true })
    scrollArea.addEventListener('scroll', syncStickyZ, { passive: true })
    syncStickyZ()
    scrollArea.addEventListener('mousedown', onTableMouseDown)
    thumb.addEventListener('mousedown', onThumbMouseDown)
    track.addEventListener('mousedown', onTrackMouseDown)
    window.addEventListener('mousemove', onWindowMouseMove)
    window.addEventListener('mouseup', onWindowMouseUp)
    window.addEventListener('resize', syncThumb)
    window.addEventListener('load', syncThumb)

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(syncThumb)
      resizeObserver.observe(scrollArea)
      resizeObserver.observe(track)
    }

    syncThumb()
  }

  function initMobileEqualHeights(section) {
    if (section.dataset.mobileRowsInit === 'true') return
    section.dataset.mobileRowsInit = 'true'

    var rafId = null
    var scheduleEqualizeMobileRows = function () {
      if (rafId) cancelAnimationFrame(rafId)
      rafId = requestAnimationFrame(function () {
        rafId = null
        equalizeMobileRows()
      })
    }

    var equalizeMobileRows = function () {
      var cells = section.querySelectorAll('[data-cmp-row]')
      if (!cells.length) return

      var groups = {}
      cells.forEach(function (cell) {
        cell.style.minHeight = ''
        var idx = cell.dataset.cmpRow
        if (!groups[idx]) groups[idx] = []
        groups[idx].push(cell)
      })

      Object.values(groups).forEach(function (group) {
        var maxH = Math.max.apply(
          null,
          group.map(function (c) {
            return c.offsetHeight
          }),
        )
        group.forEach(function (c) {
          c.style.minHeight = maxH + 'px'
        })
      })
    }

    scheduleEqualizeMobileRows()
    requestAnimationFrame(scheduleEqualizeMobileRows)
    setTimeout(scheduleEqualizeMobileRows, 120)
    setTimeout(scheduleEqualizeMobileRows, 360)

    var mobileImages = section.querySelectorAll('.cmp-mobile-column img')
    mobileImages.forEach(function (img) {
      if (!img.complete) img.addEventListener('load', scheduleEqualizeMobileRows, { once: true })
    })

    window.addEventListener('load', scheduleEqualizeMobileRows)
    window.addEventListener('resize', scheduleEqualizeMobileRows)
    window.addEventListener('orientationchange', scheduleEqualizeMobileRows)
    document.addEventListener('shopify:section:load', scheduleEqualizeMobileRows)
    document.addEventListener('shopify:section:reorder', scheduleEqualizeMobileRows)

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleEqualizeMobileRows)
    }

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(scheduleEqualizeMobileRows)
      resizeObserver.observe(section)
    }
  }

  function initMobileTitleWrapping(section) {
    if (window.innerWidth >= 750) return

    var titles = section.querySelectorAll('.cmp-mobile-product-head .cmp-product-title')
    if (!titles.length) return

    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')

    var getContainerWidth = function (el) {
      var parent = el.parentElement
      var style = window.getComputedStyle(parent || el)
      var padLeft = parseFloat(style.paddingLeft) || 0
      var padRight = parseFloat(style.paddingRight) || 0
      return (parent || el).clientWidth - padLeft - padRight
    }

    var measureWord = function (word, font) {
      ctx.font = font
      return ctx.measureText(word).width
    }

    var isCamelCase = function (word) {
      return /[a-z][A-Z]/.test(word) && word.length > 6
    }

    var breakCamelCase = function (word) {
      return word.replace(/([a-z])([A-Z])/g, '$1&shy;$2')
    }

    var breakLongWord = function (word, maxWidth, font) {
      if (measureWord(word, font) <= maxWidth) return word

      if (isCamelCase(word)) {
        var parts = word.split(/(?=[A-Z])/)
        var processedParts = parts.map(function (part) {
          if (measureWord(part, font) <= maxWidth) return part
          // Break individual part if too long
          var result = ''
          var current = ''
          for (var j = 0; j < part.length; j++) {
            var test = current + part[j]
            if (measureWord(test, font) > maxWidth && current.length >= 3) {
              result += current + '&shy;'
              current = part[j]
            } else {
              current = test
            }
          }
          result += current
          return result
        })
        return processedParts.join('&shy;')
      }

      var result = ''
      var current = ''
      for (var j = 0; j < word.length; j++) {
        var test = current + word[j]
        if (measureWord(test, font) > maxWidth && current.length >= 3) {
          result += current + '&shy;'
          current = word[j]
        } else {
          current = test
        }
      }
      result += current
      return result
    }

    titles.forEach(function (title) {
      var originalText = title.dataset.originalText || title.textContent.trim()
      if (!title.dataset.originalText) {
        title.dataset.originalText = originalText
      }

      var style = window.getComputedStyle(title)
      var font = style.fontWeight + ' ' + style.fontSize + ' ' + style.fontFamily
      var containerWidth = getContainerWidth(title) - 40

      if (containerWidth <= 0) return

      var words = originalText.split(/(\s+)/)
      var processed = words.map(function (segment) {
        if (/^\s+$/.test(segment)) return segment
        return breakLongWord(segment, containerWidth, font)
      })

      title.innerHTML = processed.join('')
    })
  }

  var wrapRafId = null
  function scheduleMobileTitleWrapping() {
    if (window.innerWidth >= 750) return
    if (wrapRafId) cancelAnimationFrame(wrapRafId)
    wrapRafId = requestAnimationFrame(function () {
      wrapRafId = null
      var sections = document.querySelectorAll('[data-cmp-section]')
      sections.forEach(initMobileTitleWrapping)
    })
  }

  window.addEventListener('resize', scheduleMobileTitleWrapping)
  window.addEventListener('orientationchange', scheduleMobileTitleWrapping)
  window.addEventListener('load', scheduleMobileTitleWrapping)

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleMobileTitleWrapping)
  }

  setTimeout(scheduleMobileTitleWrapping, 120)
  setTimeout(scheduleMobileTitleWrapping, 360)
  setTimeout(scheduleMobileTitleWrapping, 800)
  setTimeout(scheduleMobileTitleWrapping, 1500)

  // Hook into Swiper events to re-wrap when slides change
  document.addEventListener('DOMContentLoaded', function () {
    var swipers = document.querySelectorAll('.comparison-swiper')
    swipers.forEach(function (swiperEl) {
      // Wait for Swiper to initialize
      var checkSwiper = setInterval(function () {
        if (swiperEl.swiper) {
          clearInterval(checkSwiper)
          swiperEl.swiper.on('slideChange', function () {
            scheduleMobileTitleWrapping()
          })
          swiperEl.swiper.on('init', function () {
            scheduleMobileTitleWrapping()
          })
          // Run once after swiper is ready
          setTimeout(scheduleMobileTitleWrapping, 100)
        }
      }, 50)
      // Stop checking after 5 seconds
      setTimeout(function () {
        clearInterval(checkSwiper)
      }, 5000)
    })
  })

  function initSection(section) {
    if (!section) return
    initDesktopScrollbar(section)
    initMobileEqualHeights(section)
    initMobileTitleWrapping(section)
  }

  function initAllSections(root) {
    var scope = root || document
    var sections = scope.querySelectorAll('[data-cmp-section]')
    sections.forEach(initSection)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllSections(document)
    })
  } else {
    initAllSections(document)
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllSections(event.target || document)
  })
})()
